export const WORKFLOW_EXTENSION_WRAPPER_KEY =
  'confidence.workflow.extensions.wrapper.v1';

export const WORKFLOW_EXTENSION_KEY =
  'confidence.workflow.extensions.extension.v1';
